var React = require('react');

function Capsules (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M112 32A112 112 0 0 0 0 144v112h224V144A112 112 0 0 0 112 32zm312.2 80.8a114.33 114.33 0 0 0-159.3-28.1c-3.12 2.18-6.07 4.51-8.9 6.94v179.67l47 67.1 187.38-131.06z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 368a112 112 0 0 0 224 0V256H0zm555.3-67.9l-64.92-92.75L303 338.41l65 92.79a114.31 114.31 0 1 0 187.3-131.1z","className":"fa-primary","key":2})]);
}

Capsules.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Capsules;

Capsules.default = Capsules;
